export enum InfusionActionType {
  NONE = "none",
  ADD = "insert",
  UPDATE = "update",
  DELETE = "delete",
}
